import {
    newCalendarEventText,
    newEventRegionName,
} from './CalendarModuleNewEventButton.locstring.json';
import { getFirstFocusable } from '@fluentui/react/lib/Utilities';
import { observer } from 'mobx-react-lite';
import { preventFocusDuringCurrentRender } from 'owa-calendar-focus-manager';
import {
    focusNewEventButton,
    invokeNewEventByKeyboard,
    launchNewEvent,
} from 'owa-calendar-module-commanding';
import FluentCommandBarHeroButton from 'owa-fluent-commandbar/lib/FluentCommandBarHeroButton';
import loc from 'owa-localize';
import { useOrchestrator } from 'owa-react-hooks/lib/useOrchestrator';
import SkipLinkRegionToFirstFocusableChild from 'owa-skip-link/lib/components/SkipLinkRegionToFirstFocusableChild';
import * as React from 'react';
import {
    NEW_BUTTON_ANCHOR_NAME,
    NEW_BUTTON_ENTRY_SOURCE,
    KEYBOARD_SHORTCUT_ENTRY_SOURCE,
} from 'owa-calendar-compose-form-view/lib/helpers/newButtonConstants';
import type {
    QuickComposeEntrySourceType,
    FullComposeEntrySourceType,
} from 'owa-calendar-helpers-types/lib/ComposeMetricTypes';

export default observer(function CalendarModuleNewEventButton() {
    const onClickNewEvent = React.useCallback(() => {
        invokeNewEvent(NEW_BUTTON_ENTRY_SOURCE);
    }, []);

    useOrchestrator(
        invokeNewEventByKeyboard,
        () => {
            invokeNewEvent(KEYBOARD_SHORTCUT_ENTRY_SOURCE);
        },
        []
    );

    useOrchestrator(
        focusNewEventButton,
        () => {
            const newEventButtonAnchor = getNewEventButtonAnchor();
            if (newEventButtonAnchor) {
                // wait for the next animation frame so that any forms (e.g. compose) have actually closed before setting focus
                preventFocusDuringCurrentRender();
                setTimeout(() => {
                    newEventButtonAnchor?.focus();
                }, 0);
            }
        },
        []
    );

    return (
        <SkipLinkRegionToFirstFocusableChild
            role="complementary"
            regionNameResourceId={newEventRegionName}>
            <FluentCommandBarHeroButton
                text={loc(newCalendarEventText)}
                id={NEW_BUTTON_ANCHOR_NAME}
                onClick={onClickNewEvent}
            />
        </SkipLinkRegionToFirstFocusableChild>
    );
});

function invokeNewEvent(entrySource: QuickComposeEntrySourceType & FullComposeEntrySourceType) {
    launchNewEvent(entrySource, getNewEventButtonAnchor());
}

function getNewEventButtonAnchor() {
    const newEventButtonElem = document.getElementById(NEW_BUTTON_ANCHOR_NAME);
    return getFirstFocusable(
        newEventButtonElem,
        newEventButtonElem,
        true /* includeElementsInFocusZones */
    ) as HTMLDivElement;
}
